import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { BadgeProvider } from './contexts/BadgeContext';
import { CookiesProvider } from 'react-cookie';
import { useAuth } from './hooks/useAuth';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Forum from './pages/Forum';
import PostDetail from './pages/postDetail';
import CreatePost from './pages/CreatePost';
import PostEdit from './pages/PostEdit';
import UserProfile from './pages/UserProfile';
import OtherUserProfile from './pages/OtherUserProfile'; // Import the new component
import Blogs from './pages/Blogs';
import BlogDetail from './pages/BlogDetail';
import CreateBlog from './pages/CreateBlog';
import BlogEdit from './pages/BlogEdit';
import About from './pages/About';
import './App.css';
import 'shepherd.js/dist/css/shepherd.css';
import './styles/shepherd-overrides.css';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import VerifyEmail from './pages/VerifyEmail';
import AdminPanel from './pages/AdminPanel';


const tourOptions = {
  defaultStepOptions: {
    cancelIcon: { enabled: true },
    classes: 'shadow-md bg-[#1a1a1a] text-white',
    scrollTo: { behavior: 'smooth', block: 'center' },
  },
  useModalOverlay: true,
};

// Protected Route component to check authentication
const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  if (!user) {
    // User is not authenticated, redirect to login
    return <Navigate to="/login" />;
  }
  return children;
};

const AdminRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="text-white p-8">Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  if (user.role !== 'ADMIN') {
    return <Navigate to="/" />;
  }

  return children;
};

function App() {
  return (
    <CookiesProvider>
      <AuthProvider>
        <BadgeProvider>
          <Router>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/admin" element={
                <AdminRoute>
                  <AdminPanel />
                </AdminRoute>
              } />

              <Route path="/login" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/verify-email" element={<VerifyEmail />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/forum" element={<Forum />} />
              <Route path="/about" element={<About />} />
              <Route path="/post/edit/:id" element={<PostEdit />} />
              <Route path="/post/:postId" element={<PostDetail />} />
              <Route path="/create-post" element={
                <ProtectedRoute>
                  <CreatePost />
                </ProtectedRoute>
              } />
              
              {/* Profile routes - separate for self vs others */}
              <Route path="/profile/user/:user_id" element={<OtherUserProfile />} />
              <Route path="/profile/me" element={
                <ProtectedRoute>
                  <UserProfile />
                </ProtectedRoute>
              } />

              {/* Blog routes */}
              <Route path="/blog" element={<Blogs />} />
              <Route path="/blog/edit/:id" element={<BlogEdit />} />
              <Route path="/blog/:id" element={<BlogDetail />} />
              <Route path="/blog/create" element={
                <ProtectedRoute>
                  <CreateBlog />
                </ProtectedRoute>
              } />
            </Routes>
          </Router>
        </BadgeProvider>
      </AuthProvider>
    </CookiesProvider>
  );
}

export default App;